import { createHookWithCallbacks } from '@move-frontend/auth';
import { sendRecoveryLinkWithCallbacks } from './sendRecoveryLinkWithCallbacks';

export const useSendRecoveryLinkWithCallbacks = createHookWithCallbacks(
	sendRecoveryLinkWithCallbacks,
);
